<template>
    <div class="container">
        <div class="fixed-div">
            <div class="fiexcar" @mouseenter="barfun(1)" @mouseleave="barfun(9)">
                <img src="../assets/svg/phone10.svg" v-if="iscar == 1" />
                <img src="../assets/svg/phone10.svg" v-else />
                <div class="red">电话</div>
            </div>
            <div class="fiexcar" @mouseenter="barfun(2)" @mouseleave="barfun(9)">
                <img src="../assets/svg/wb10.svg" v-if="iscar == 2" />
                <img src="../assets/svg/wb10.svg" v-else />

                <div class="red">微博</div>
            </div>
            <div class="fiexcar" @mouseenter="barfun(3)" @mouseleave="barfun(9)">
                <img src="../assets/svg/wx10.svg" v-if="iscar == 3" />
                <img src="../assets/svg/wx10.svg" v-else />
                <div class="red">微信</div>
            </div>
        </div>
        <div class="fixed-up">
            <div class="fiexcar-up" @click="barfun(4)">
                <img src="../assets/svg/up10.svg" v-if="iscar == 4" />
                <img src="../assets/svg/up10.svg" v-else />
                <!-- <div>微信</div> -->
            </div>
        </div>
        <div class="fixed-car" style="text-align: center;" v-if="iscar == 3">
            <p class="fs-16" style="font-weight: bolder;padding-top: 20px">宁波考试院</p>
            <p class="A199 mt5" v-if="iscar == 3">微信扫码关注官方公众号</p>
            <img v-if="iscar == 3" src="../assets/home/wxcar.png" class="mt5" />
        </div>
        <div class="fixed-carwb" style="text-align: center;" v-if=" iscar == 2">
            <p class="fs-16" style="font-weight: bolder;padding-top: 20px">宁波考试院</p>
            <p class="A199 mt5" v-if="iscar == 2">微博扫码关注官方账号</p>
            <img v-if="iscar == 2" src="../assets/wb.png" class="mt5" />
        </div>

        <div class="fixed-carp" style="text-align: center;" v-if="iscar == 1">
            <div style="line-height: 20px; margin-top: 10%;">
                <p class="A199">咨询室电话（傅老师）</p>
                <p class="fs-16 flex jc-c  ai-c mr15" style="font-weight: bolder; margin-left: 8px;padding-top: 4px;">
                    <img src="../assets/phone.png" class="pr4" />87323004
                </p>
            </div>

        </div>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted } from 'vue'
let list = ref([])
let iscar = ref('')
onBeforeMount(() => { listup() })
onMounted(() => { console.log('3.-组件挂载到页面之后执行-------onMounted') })

const listup = () => { }
const barfun = (key) => {
    switch (key) {
        case 1:
            iscar.value = key
            break;
        case 2:
            iscar.value = key
            break;
        case 3:
            iscar.value = key
            break;
        case 4:
            iscar.value = key
            window.scrollTo(0, 0);
            break;
        case 9:
            iscar.value = key
            break;
        default:
            break;
    }
}
</script>
<style lang="less" scoped>
.fixed-up {
    position: fixed;
    right: 0;
    top: 620px;
    width: 72px;
    height: 72px;
    background: #FFFFFF;
    box-shadow: 0px 0px 14px 0px rgba(212, 220, 229, 0.3);
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    margin-right: 8px;
    padding-top: 10px;

    .fiexcar-up {
        text-align: center;
        padding: 10px;
        padding-top: 10px;
        cursor: pointer;
        width: 56px;
        height: 72px;
        line-height: 72px;

        img {
            width: 36px;
            height: 36px;
        }
    }
}

.fixed-div {
    position: fixed;
    right: 0;
    top: 360px;
    width: 72px;
    height: 238px;
    background: #FFFFFF;
    box-shadow: 0px 0px 14px 0px rgba(212, 220, 229, 0.3);
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    margin-right: 10px;
    padding-top: 10px;
}

.fixed-car {
    right: 76px;
    position: fixed;
    top: 440px;
    margin-right: 18px;
    padding-top: 6px;
    width: 188px;
    height: 220px;
    background: #FFFFFF;
    box-shadow: 0px 0px 14px 0px rgba(212, 220, 229, 0.3);
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
}
.fixed-carwb {
    right: 76px;
    position: fixed;
    top: 420px;
    margin-right: 18px;
    padding-top: 6px;
    width: 188px;
    height: 220px;
    background: #FFFFFF;
    box-shadow: 0px 0px 14px 0px rgba(212, 220, 229, 0.3);
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
}

.fixed-carp {
    right: 76px;
    position: fixed;
    top: 360px;
    margin-right: 18px;
    padding-top: 6px;
    width: 188px;
    height: 86px;
    background: #FFFFFF;
    box-shadow: 0px 0px 14px 0px rgba(212, 220, 229, 0.3);
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
}

.fiexcar {
    text-align: center;
    padding: 10px;
    padding-top: 5px;
    cursor: pointer;
    width: 56px;
    height: 60px;
    padding-top: 10px;

    img {
        width: 30px;
        height: 30px;
    }
}
</style>
